module.exports = __webpack_public_path__ + "static/img/describe_shine.6ed2070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/describe_shine.png
// module id = rZfs
// module chunks = 1